import { useEffect, useState } from "react";
import axios from "axios";
import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./SlickSlider.scss";
import { Link } from "react-router-dom";

function SlickSlider() {
  const [CompanyMember, setCompanyMember] = useState([]);

  const settings = {
    className: "center",
    infinite: true,
    lazyLoad: true,
    centerPadding: "60px",
    slidesToShow: 4,
    swipeToSlide: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
  };

  const getCompanyMember = async () => {
    const response = await axios.get("/api/member-company", {
      params: { state: 1 },
    });
    setCompanyMember(response.data.data);
  };

  const Members = () => {
    let idx = 0;
    // console.log(CompanyMember.length);
    return CompanyMember.map((item) => {
      const link = "//" + item.link;
      const key = `link_${idx}`;
      // console.log("1"+item);
      return (
        <div key={key} className="co_logo_wrap">
          <Link target="_blank" to={link} style={{ height: "100%" }}>
            <img
              alt={item.name}
              src={"data:image/png;base64," + item.ciImage}
            />
          </Link>
        </div>
      );
    });
  };

  useEffect(() => {
    getCompanyMember();
  }, []);

  return (
    <div className="contain_slide">
      <div className="contain">
        <Slider {...settings} class="slide_wrapper">
          {Members()}
        </Slider>
      </div>
    </div>
  );
}

export default SlickSlider;
